import { observer } from 'mobx-react'
import Heading from '../Heading'
import NavigationMenu, {
  NavigationItem,
  NavigationItemProps,
} from './NavigationMenu'

interface SidebarProps {
  title: string
  subtitle: string
  links: NavigationItemProps[]
}

const Sidebar = observer(({ title, subtitle, links }: SidebarProps) => {
  return (
    <nav className="navigation-menu-nav">
      <Heading title={title} subtitle={subtitle} size="large" />
      <NavigationMenu>
        {links.map((link) => (
          <NavigationItem key={link.to} {...link} />
        ))}
      </NavigationMenu>
    </nav>
  )
})

export default Sidebar
